import {
  APPLY_REWARD_ERROR_MESSAGES_CONTENT_TYPE,
  type ApplyRewardErrorMessages,
  useApplyRewardErrorMessage as useSharedApplyRewardErrorMessage,
} from '@sg/shared-fe/features/loyalty';

import { useContentfulContentTypeEntry } from '@order/Contentful';

/** Given an apply reward response, return the error message. */
export const useApplyRewardErrorMessage = () => {
  const { data } = useContentfulContentTypeEntry<ApplyRewardErrorMessages>({
    contentType: APPLY_REWARD_ERROR_MESSAGES_CONTENT_TYPE,
  });

  return useSharedApplyRewardErrorMessage({ messages: data?.fields });
};
